import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useCallback,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import SnTree from "@shared/components/GridV2/SnTree"; // 공통 트리 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnButton from "@shared/components/SnButton";

interface Props {
  Menuprops: menuInfo;
}

const SN_PRD_WRK_REP_010 = forwardRef((_props: Props, ref) => {
  //#region  variable
  const treeRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    tree: React.createRef(),
  });

  const searchRef = useRef<any>(null);

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        // 초기값에 공유로 받은 값이 있으면 덮어쓰지 않고 유지
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));

        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  //#region onSearch
  const onSearch = async (searchData: any) => {
    try {
      const searchDataToUse = searchData || searchRef.current.getFormdata();
      const params = {
        id: "sn_prd_wrk_rep_010_01",
        params: searchDataToUse,
      };

      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0] || [],
      });
    } catch (error: any) {}
  };
  //#endregion

  //#region Tree Events
  const onRowDataReady = useCallback(() => {
    treeRefs.current["tree"].current?.selectAndFocusRow(0);
  }, []);

  const onTreeBtnsClick = async (id: string) => {
    switch (id) {
      case "Expand":
        treeRefs.current["tree"].current.setExpandedAll(true);
        break;
      case "Coalesce":
        treeRefs.current["tree"].current.setExpandedAll(false);
        break;
    }
  };

  const autoGroupColumnDef = {
    headerName: "Level",
    field: "no_level",
    minWidth: 300,
    cellRendererParams: {
      suppressCount: true, // 하위 아이템 개수 숨기기
      suppressDoubleClickExpand: true, // 더블 클릭으로 확장/축소 비활성화
      suppressHoverHighlight: false,
    },
  };

  const getRowId = useCallback(
    (params: any) => String(params.data.no_level),
    []
  );
  //#endregion

  //#region useMemo
  const grids = useMemo(
    () => ({
      tree: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onRowDataReady,
        },
      },
    }),
    [columns, dataSources, onRowDataReady]
  );
  //#endregion

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0">
        <SnTree
          ref={treeRefs.current["tree"]} // Grid Name
          columnConfig={grids.tree.columns} // 컬럼 설정 전달
          rowData={grids.tree.dataSource} // Datasource
          etcProps={{
            isEditable: false,
            rowSelection: "single",
            title: "추적정보",
          }}
          useTreeTempKey={false}
          events={grids.tree.events}
          treeProps={{
            treeDataParentIdField: "no_plevel",
            treeIdKey: "no_level",
            groupDefaultExpanded: -1,
            autoGroupColumnDef: autoGroupColumnDef,
            getRowId: getRowId,
          }}
          header={
            <div>
              <SnButton
                text="전체전개"
                onClick={() => onTreeBtnsClick("Expand")}
              />
              <SnButton
                text="전체닫기"
                onClick={() => onTreeBtnsClick("Coalesce")}
              />
            </div>
          }
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_WRK_REP_010;
